<template>
  <div ref="refChartLine"
       style="width: 100%; height: 100%;">
  </div>
</template>

<script>
export default {
  data() {
    return {
      chartLine: null, // 图表指针
      optionLine: {} // 图表参数
    }
  },
  components: {},
  props: {
    updata: {
      type: Object,
      default: () => ({
        xData: [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月'
        ],
        seriesData: {
          water: [60, 70, 60, 70, 60, 80, 75, 76, 70, 80, 70, 60],
          electricity: [60, 70, 66, 68, 70, 78, 75, 76, 70, 80, 70, 60]
        }
      })
    }
  },
  mounted() {
    this.initOption()
  },
  beforeDestroy() {
    if (this.chartLine) this.chartLine.dispose()
  },
  watch: {
    updata: {
      handler(newData) {
        this.updateOption(newData)
      },
      // immediate: true, // 初始化后会立即触发一次
      deep: true // 深层监听 即遍历所有子对象 对性能稍有影响
    }
  },
  methods: {
    initOption() {
      this.chartLine = this.$echarts.init(this.$refs.refChartLine)
      this.updateOption(this.updata)
    },
    updateOption(newData) {
      this.optionLine = {
        legend: {
          show: true,
          top: '5%',
          left: 'center',
          textStyle: {
            fontSize: 14,
            fontWeight: 400,
            fontFamily: 'Source Han Sans SC',
            color: '#FFFFFF',
            align: 'left'
          },
          data: ['水', '电']
        },
        tooltip: {
          trigger: 'item'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            show: true,
            color: '#5C9ADD',
            fontSize: 14,
            fontWeight: 400
            // formatter: '{value} 次', // 格式化标签文本，例如在数值后添加单位
            // rotate: 45 // 标签旋转角度，例如45度
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#4075A5',
              width: 2,
              type: 'solid'
            }
          },
          data: newData.xData
        },
        yAxis: [
          {
            type: 'value',
            name: '水用量',
            position: 'left',
            nameTextStyle: {
              fontSize: 14,
              fontWeight: 400,
              fontFamily: 'Source Han Sans SC',
              color: '#5C9ADD'
            },
            axisLabel: {
              show: true,
              formatter: '{value} m3',
              color: '#5C9ADD',
              fontSize: 14,
              fontWeight: 400
              // formatter: '{value} 次', // 格式化标签文本，例如在数值后添加单位
              // rotate: 45 // 标签旋转角度，例如45度
            },
            axisLine: {
              show: false
            },
            splitLine: {
              //背景线条
              show: true,
              lineStyle: {
                color: '#4075A5',
                type: 'dashed'
              }
            }
          },
          {
            type: 'value',
            name: '电用量',
            position: 'right',
            nameTextStyle: {
              fontSize: 14,
              fontWeight: 400,
              fontFamily: 'Source Han Sans SC',
              color: '#5C9ADD'
            },
            axisLabel: {
              show: true,
              formatter: '{value} kwh',
              color: '#5C9ADD',
              fontSize: 14,
              fontWeight: 400
              // formatter: '{value} 次', // 格式化标签文本，例如在数值后添加单位
              // rotate: 45 // 标签旋转角度，例如45度
            },
            axisLine: {
              show: false
            },
            splitLine: {
              //背景线条
              show: true,
              lineStyle: {
                color: '#4075A5',
                type: 'dashed'
              }
            }
          }
        ],
        series: [
          {
            name: '水',
            type: 'line',
            smooth: true,
            xAxisIndex: 0,
            yAxisIndex: 0, // 使用第一个 y 轴
            lineStyle: {
              width: 6,
              color: '#06E3FF'
            },
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#06E3FF', // 默认颜色
              emphasis: {
                // 悬停时样式
                color: '#FFFFFF' // 悬停颜色（绿色）
              }
            },
            areaStyle: {
              color: {
                type: 'linear', // 使用线性渐变
                x: 0, // 渐变起始点的横坐标（0%）
                y: 0, // 渐变起始点的纵坐标（0%）
                x2: 0, // 渐变结束点的横坐标（0%）
                y2: 1, // 渐变结束点的纵坐标（100%）
                colorStops: [
                  {
                    offset: 0,
                    color: '#69BF6199'
                  },
                  {
                    offset: 1,
                    color: '#78D77101'
                  }
                ]
              }
            },
            data: newData.seriesData.water
          },
          {
            name: '电',
            type: 'line',
            smooth: true,
            xAxisIndex: 0,
            yAxisIndex: 1, // 使用第二个 y 轴
            lineStyle: {
              width: 6,
              color: '#5BEA4C'
            },
            symbol: 'circle',
            symbolSize: 6,
            itemStyle: {
              color: '#5BEA4C', // 默认颜色
              emphasis: {
                // 悬停时样式
                color: '#FFFFFF' // 悬停颜色（绿色）
              }
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#69BF6199'
                  },
                  {
                    offset: 1,
                    color: '#78D77101'
                  }
                ]
              }
            },
            data: newData.seriesData.electricity
          }
        ]
      }

      this.chartLine.setOption(this.optionLine, {
        notMerge: true // 不合并以前的配置，直接使用新的配置覆盖
        // lazyUpdate: true // 延迟更新视图，直到下一次渲染循环，这样可以批量更新多个属性而只触发一次重渲染，提高性能。
      })
    }
  }
}
</script>

<style scoped>
</style>